import React from "react";
import { Box } from "@mui/material";
import { FormikProps } from "formik";
import "./MyTextField.css";
import { AirlineStopsRounded } from "@mui/icons-material";

interface CustomInputProps {
  formik: FormikProps<any>;
  name: string;
  type: string;
  placeholder: string;
  icon?: React.ReactNode | string;
  iconName?: string;
}

const MyTextField: React.FC<CustomInputProps> = ({
  formik,
  name,
  type,
  placeholder,
  icon,
}) => {
  const error = formik.touched[name] && Boolean(formik.errors[name]);
  const helperText = formik.touched[name] && (formik.errors[name] as string);

  return (
    <Box sx={{ my: 2,mx:3 }}>
      <Box className="group">
        {icon ? (
          <span style={{color:error?"red":""}} className="icon">{icon}</span>
        ) : (
          <span className="icon">
            <AirlineStopsRounded fontSize="small" />
          </span>
        )}
        <input
          className={`input ${error ? "input-error" : ""}`}
          type={type}
          placeholder={placeholder}
          {...formik.getFieldProps(name)}
        />
      </Box>
      <span>
        {error && (
          <div
            style={{ fontFamily: "Ubuntu", maxWidth: "300px",marginTop:"7px" }}
            className="error-text"
          >
            {helperText}
          </div>
        )}
      </span>
    </Box>
  );
};

export default MyTextField;
